import type { MantineSize } from '@mantine/core'
import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & {
	source?: string
	fit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
	width?: string
	height?: string
	radius?: MantineSize
	placeholder: boolean
	placeholderIconSize?: string
	fallbackSrc?: string
}

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'source', displayName: 'Source', group: 'Data', type: 'string' }),
			getPortDef({
				name: 'fallbackSrc',
				displayName: 'Fallback image',
				group: 'Data',
				type: 'string',
				default: './noImage.svg'
			}),
			getPortDef({
				name: 'fit',
				displayName: 'Fit',
				group: 'Dimensions',
				type: [
					{ value: 'contain', label: 'Contain' },
					{ value: 'cover', label: 'Cover' },
					{ value: 'fill', label: 'Fill' },
					{ value: 'none', label: 'None' },
					{ value: 'scale-down', label: 'Scale-down' },
				],
				default: 'cover',
			}),

			getPortDef({ name: 'width', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'height', displayName: 'Height', group: 'Dimensions', type: 'string', default: '100%' }),
			getPortDef({
				name: 'radius',
				displayName: 'Radius',
				group: 'Styles',
				type: sizes,
				default: 'xs',
			}),
			getPortDef({
				name: 'placeholder',
				displayName: 'Placeholder',
				group: 'Params',
				type: 'boolean',
				default: true,
			}),
			getPortDef({
				name: 'placeholderIconSize',
				displayName: 'Placeholder icon size',
				group: 'Params',
				type: 'string',
				dependsOn: (p: Props) => p.placeholder === true,
				default: '24'
			}),
		],
	},
} satisfies ReactNodeDef
